import doLog from "./log";
import cookieInfo from '@alife/bc-cookie-info';
export default () => {
  if (cookieInfo.getBuyerLocale()?.toLocaleLowerCase() !== 'en_us') {
    doLog('/sc.details.multi.language', `locale=${cookieInfo.getBuyerLocale()}`, 'EXP')
  }

  // 自动曝光
  var q = window.goldlog_queue || (window.goldlog_queue = []);
  // 全局自动曝光
  q.push({
    action: "goldlog.setMetaInfo",
    arguments: [
      "aplus-auto-exp",
      [
        {
          logkey: "/sc.details.module",
          cssSelector: "[detail-module-name] > div",
          pkgSize: 9,
        },
        {
          logkey: '/sc.details.recommend',
          cssSelector: "[data-recommend-param]",
          props: "[data-recommend-param]",
          pkgSize: 9,
        },
      ],
    ],
  });
  q.push({
    action: 'goldlog.setMetaInfo',
    arguments: [
      'aplus-auto-exp-userfn',
      (element: Element) => {
        if (element.parentElement?.getAttribute('detail-module-name')) {
          const moduleName = element.parentElement?.getAttribute('detail-module-name');
          doLog(`/sc.details.${moduleName}`, '', 'EXP');
          return `module=${moduleName?.replace('module_', '')}`
        }
        // 推荐打点
        if (element.getAttribute('data-recommend-param')) {
          const moduleName = element.getAttribute('data-recommend-param');
          return `data-recommend-params=${moduleName}`
        }
      },
    ],
  });
  // 全局自动点击
  q.push({
    action: "goldlog.setMetaInfo",
    arguments: [
      "aplus-auto-clk",
      [
        {
          logkey: "/sc.details.module",
          cssSelector: "[detail-module-name] > div",
          filter: "detail-module-name",
        },
      ],
    ],
  });
  q.push({
    action: 'goldlog.setMetaInfo',
    arguments: [
      'aplus-auto-clk-userfn',
      (element: Element) => {
        if (element.parentElement) {
          return `module=${element.parentElement?.getAttribute('detail-module-name')?.replace('module_', '')}`
        }
      },
    ],
  });
};
